/* src/app/forms/push-pedidos/push-pedidos.component.scss */
:host {
  display: flex;
  flex-direction: column;
  height: 100%;
  overflow: auto;
}
.direita {
  width: 60%;
  height: 100%;
  padding-top: 5px;
  padding-bottom: 5px;
  padding-left: 15px;
  display: flex;
  flex-direction: column;
}
.mktplace-info {
  width: 100%;
  display: flex;
  flex-direction: row;
  gap: 8px;
  align-items: center;
}
.titulo {
  font-size: 80%;
  margin-right: 12px;
}
.label {
  padding-right: 12px;
  font-size: 120%;
}
.cardcontent {
  display: flex;
  flex-direction: row;
  height: 100%;
  overflow: auto;
  position: relative;
}
.div45 {
  height: 45%;
}
.div55 {
  position: relative;
  height: 100%;
  display: flex;
  overflow: auto;
}
.div-pedido {
  position: relative;
  height: 100%;
}
.div90 {
  height: 100%;
  display: flex;
  flex-direction: column;
  overflow: auto;
  gap: 10px;
}
.mat-mdc-form-field {
  width: 100%;
}
.div10 {
  padding-top: 5px;
  display: flex;
  flex-direction: column;
}
.div100 {
  text-align: center;
  display: block;
}
.listitem {
  padding: 10px;
}
.esquerda {
  width: 40%;
  height: 100%;
  padding-bottom: 5px;
  padding-right: 15px;
  display: flex;
  flex-direction: column;
}
.esquerda form .mat-mdc-form-field {
  width: 100%;
}
form {
  display: flex;
  flex-direction: column;
  height: 100%;
  gap: 8px;
  overflow: auto;
  padding-top: 10px;
}
.toolbar {
  height: 100%;
  font-size: 16px;
  overflow: auto;
  height: 100%;
  display: flex;
  flex-direction: column;
}
.buttondiv {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  width: 100%;
  align-items: center;
}
.span {
  flex: 1 1 auto;
  font-size: 14px;
  text-align: right;
  padding-right: 12px;
  display: inline-block;
  width: 100%;
  justify-content: center;
}
.mat-mdc-form-field {
}
.mat-mdc-form-field .mat-form-field-wrapper {
  padding-bottom: 0;
}
.mat-mdc-form-field .mat-form-field-underline {
  bottom: 0;
}
.mat-mdc-card {
  display: flex;
  flex-direction: column;
  height: 100%;
  padding: 5px;
}
.customlist {
  display: flex;
  flex-direction: column;
  height: 100%;
  overflow: auto;
  position: relative;
  width: 100%;
}
.customlist ::ng-deep .ant-spin-nested-loading {
  display: flex;
  flex-direction: column;
  height: 100%;
  min-height: 0;
  overflow: auto;
}
.customlistdireita {
  overflow: auto;
  height: 100%;
  display: flex;
  flex-direction: column;
}
.mat-mdc-card-actions {
  float: right;
}
.content {
  height: 100%;
  display: flex;
  flex-direction: column;
  overflow: auto;
}
.view-component-body {
  height: 100% !important;
}
.rotate {
  animation: rotation 2s infinite linear;
}
@keyframes rotation {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(359deg);
  }
}
.space {
  gap: 10px;
  display: flex;
  flex-direction: row;
}
.full-width {
  width: 100%;
}
.header-template {
  display: flex;
  flex-direction: row;
  align-items: center;
  width: 100%;
}
:host ::ng-deep .ant-card-body {
  display: flex;
  flex-direction: column;
  height: 100%;
  overflow: auto;
  position: relative;
}
/*# sourceMappingURL=push-pedidos.component.css.map */
